const resources = {
    signInLead1: 'Sign in',
    signInLead2: 'for a more personalized experience or',
    signInLeadLink: 'create an account',
    signInFree: 'Sign In for FREE Shipping',
    signInAccount: 'Don’t have an account?',
    signInAccountLink: 'Create an account',
    signInCTA: 'Sign In',
    status: 'You’re a',
    points: 'with',
    join: 'Join Beauty Insider',
    earn: 'to earn points with every purchase.',
    ccRewards: 'Credit Card Rewards'
};

module.exports = function getResource(label) {
    return resources[label];
};
